import { Environment } from "app/models/base.model";

export const environment :Environment = {
    production: false,
    apiUrl: 'https://api.scheduler.lycusinc.com/',
    lpmKey :'395fe7bf-d5f8-4380-bafe-5d015ecaf190',
    lpmSecret :'G<2R2::k4@Rc',
    VGS_CONFIG: { vaultId: "tntmrhnuvtw", environment: "sandbox", version: "2.12.0" },
    lollyEndpoint: "https://dev.lollylaw.com/",
    showDeveloperErrors : false,
    lollyLawAppLink: "https://hyboria.lollylaw.com/",
  };
